module.exports = __webpack_public_path__ + "img/hand-holding-heart.b35bda91.svg";